import styled from 'styled-components'

export const FeaturedListingOuter = styled.div`
  padding-top: 96px;

  ${p => p.theme.breakpoints.down('sm')} {
    padding-top: 64px;
  }

  ${p => p.theme.breakpoints.down('xs')} {
    padding-top: 48px;
  }

  display: flex;
  ${({ featuredListing, theme }: any) => {
    if (featuredListing) {
      return `
      display: flex;
      ${theme.breakpoints.down('sm')} {
        display: block;
      }
      `
    }
  }}

  div.listings__featured-listing {
    border-top: 1px solid ${p => p.theme.webMktPalette.grayNeutral[30]};
  }
`

export const ListingContainerTopSection = styled.div`
  padding-top: 64px;
`
export const ListingContainerBottomSection = styled.div`
  margin-top: 64px;
  display: flex;
`

export const ListingContainerLeftSection = styled.div`
  margin-top: 4px;
  min-width: 282px;

  .Listing__Year-title {
    margin-bottom: 12px;
  }

  .Listing__Year-Container {
    display: flex;
    flex-direction: column;
  }
  .listing_year--option-text {
    display: inline-block;
    padding-left: 10px;
  }

  .Financial_News-Block {
    margin-top: 32px;
  }
  .financial_news-text {
    margin-bottom: 8px;
  }

  ${p => p.theme.breakpoints.down('md')} {
    min-width: 244px;
  }

  ${p => p.theme.breakpoints.down('sm')} {
    display: none;
  }
`

export const ListingContainerRightSection = styled.div`
  width: 100%;
  height: 100%;
`

export const ListingContainerTopButtons = styled.div`
  .Listing__Buttons-Styles {
    background: ${p => p.theme.webMktPalette.button.secondaryWhite};
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
    height: 48px;
    min-width: 151px;
    padding: 0 16px;
    left: 135px;
    top: 0px;
    border-radius: 0px;
    border: 1px solid ${p => p.theme.webMktPalette.text.tertiaryLight};
    margin-right: 16px;
  }

  .active {
    background: ${p => p.theme.webMktPalette.blue[50]};
  }

  .active > p {
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
  }

  ${p => p.theme.breakpoints.down('sm')} {
    display: none;
  }
`

export const ListingContainerTopDropDowns = styled.div`
  .Jobs__FiltersContainer {
    display: none;
    .PartnersLocator__filterClosed {
      margin-bottom: 0px;
    }
  }

  ${p => p.theme.breakpoints.down('sm')} {
    .Jobs__FiltersContainer {
      display: flex;
      & > div {
        flex: 1;
        margin-left: 16px;
      }
    }
  }
  ${p => p.theme.breakpoints.down('xs')} {
    .Jobs__FiltersContainer {
      display: block;
      & > div {
        margin-left: 0px;
      }
    }
  }
  .PartnersLocatorFilters {
    margin-left: 0px;
  }
`

export const PaginationContainer = styled.div`
  padding: 64px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  justify-content: flex-start;
`

export const InnerWrapper = styled.div`
${({ useCase, theme }: any) => {
  if (useCase === 'Offices' || useCase === 'Leadership') {
    return `
    background-color: ${theme.webMktPalette.background.gray};`
  } else {
    return ` background-color: ${theme.webMktPalette.background.white};`
  }
}}}`

export const AllTabOrderWrapper = styled.div`
  padding-bottom: 96px;
`
